<template>
    <div class="contactUs">
        <div style="height: 5.29em;width:100%;position: fixed;left: 0;z-index: 10000;
        top: 0;background-color:#fff;" class="flex flex-a-c">
            <img src="../assets/img/logo.png" style="width: 8.33em;height: 1.96em;margin-left: 2.04em;" alt="">
        </div>
        <div style="height: 5.29em;"></div>
        <banner type="6" :phone="true"></banner>
        <div class="contactType">
            <div>
                <span class="font-600 color-red">地址：</span>
                <span style="margin-left: .38em;">{{contact.address}}</span>
            </div>
            <div style="margin-top: 1.63em;">
                <span class="font-600 color-red">邮编：</span>
                <span style="margin-left: .38em;">{{contact.zip_code}}</span>
            </div>
            <div style="margin-top: 1.63em;">
                <span class="font-600 color-red">邮箱：</span>
                <span style="margin-left: .38em;">{{contact.email}}</span>
            </div>
            <div style="margin-top: 1.63em;">
                <span class="font-600 color-red">联系人：</span>
                <span style="margin-left: .38em;">{{contact.users}}</span>
            </div>
        </div>
        <div class="contactForm">
            <div class="font-600 font-20 color-red">
                您有什么需要跟我们说？
            </div>
            <div class="position-r">
                <div class="label">姓名:</div>
                <input type="text" v-model="form.username" placeholder="请输入您的姓名,方便我们称呼您">
                <img class="xinhao" src="../assets/img/xinhao.png" width="16" height="16" alt="">
            </div>
            <div class="position-r">
                <div class="label">邮箱:</div>
                <input type="text" v-model="form.email" placeholder="请输入您发邮箱地址，我们将会发送回复给您">
                <img class="xinhao" src="../assets/img/xinhao.png" width="16" height="16" alt="">
            </div>
            <div class="position-r">
                <div class="label">联系方式:</div>
                <input type="text" v-model="form.mobile" placeholder="请输入您的手机号码，方便我们联系您">
                <img class="xinhao" src="../assets/img/xinhao.png" width="16" height="16" alt="">
            </div>
            <div class="position-r">
                <div class="label">地址:</div>
                <input type="text" v-model="form.address" placeholder="请输入您的办公地址，如有需要，我们可上门拜访">
                <img class="xinhao" src="../assets/img/xinhao.png" width="16" height="16" alt="">
            </div>
            <div>
                <div class="label">您的留言:</div>
                <textarea v-model="form.content" placeholder="请输入您的姓名,方便我们称呼您"/>
            </div>
            <div @click="submit" class="btn">
                <img src="../assets/img/fasong.png" alt="">
                <span class="font-600" style="margin-left: .88em;">发送</span>
            </div>
        </div>
        <div v-if="toast" class="text-center flex flex-j-c flex-a-c"
             style="color:#fff;width: 214px;height: 50px;background: #000000;border-radius: 8px;opacity: 0.5;line-height: 50px;
                    position: fixed;left: 50%;bottom: 300px;z-index: 1000;">
            <img v-if="toast == '发送成功'" src="../assets/img/queding.svg" alt="">
            <span class="ml-2">{{toast}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'contactUs',
        props: {},
        data() {
            return {
                contact: {},
                form: {},
                toast: ''
            }
        },
        async mounted() {
            this.getContact()
        },
        methods: {
            async getContact() {
                this.contact = await this.$api.getContact()
            },
            async submit() {
                let data = await this.$api.addMessage(this.form)
                if (data.code) {
                    this.toast = '发送成功'
                } else {
                    this.toast = data.info
                }
                setTimeout(() => {
                    this.toast = ''
                }, 3000)
            }
        },

    }
</script>
<style scoped lang="scss">
    .contactUs {
        font-size: 12px;

        .contactType {
            padding: 2.8em 2.13em;

            .w-4em {
                display: inline-block;
                width: 4em;
            }
        }

        .contactForm {
            padding: 4.38em 2.13em 2.38em;
            background-color: $grey;

            .label {
                line-height: 4.17em;
            }

            input {
                width: 100%;
                height: 3.33em;
                background: #FFFFFF;
                border: 1px solid #E3E6E8;
                padding: 1.17em 1.38em;
                box-sizing: border-box;
                position: relative;
            }

            .xinhao {
                position: absolute;
                right: .92em;
                top: 5.8em;
                width: .5em;
                height: .5em;
            }

            textarea {
                width: 100%;
                height: 18.33em;
                padding: 1.17em 1.38em;
                box-sizing: border-box;
                background: #FFFFFF;
                border: 1px solid #E3E6E8;
            }

            .btn {
                margin-top: 3.29em;
                width: 100%;
                height: 3.33em;
                background: #BD2C2E;
                border-radius: 2rem;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: 1.33em;
                    height: 1.33em;
                }
            }
        }

    }
    /deep/ .swiper-pagination-bullet {
        height: .7em;
        width: .7em;
    }
</style>
